import { Controller } from "@hotwired/stimulus"

// Handles company setup form interactions
export default class extends Controller {
  static targets = [ "nameInput", "nameSuccess" ]
  
  connect() {
    this.validateName()
  }
  
  validateName() {
    const name = this.nameInputTarget.value.trim()
    
    if (name.length >= 2) {
      this.nameSuccessTarget.classList.add("success-fade-in")
      this.nameSuccessTarget.classList.remove("opacity-0")
    } else {
      this.nameSuccessTarget.classList.remove("success-fade-in")
      this.nameSuccessTarget.classList.add("opacity-0")
    }
  }
} 